import styled from 'styled-components';
import Image from '@tcp/core/src/components/common/atoms/Image';

const StyledModal = styled.div`
  position: fixed;
  top: 12vh;
  right: 0;
  width: 220px;
  height: auto;
  padding: 30px 20px 10px;
  min-height: 450px;

  animation: slide-in 0.5s forwards;
  background: linear-gradient(-63deg, #00a7e1, #00a7e1 50%, #44b8e7 50%, #44b8e7 100%);
  z-index: 100;

  @keyframes slide-in {
    0% {
      transform: translateX(100%);
    }
    100% {
      transform: translateX(0%);
    }
  }

  .rtps-modal-text {
    text-align: center;
    text-transform: uppercase;
  }
  .rtps-modal-terms {
    text-align: center;
    padding: 5px 0px;
    span a {
      color: black;
    }
  }
  .rtps-first-name-text {
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .rtps-no-thanks {
    padding: 10px;
    text-align: center;
    font-size: 14px;
    color: #000;
    text-transform: uppercase;
  }
  .rtps-apply-now-button {
    margin-top: 20px;
    padding: 10px;
  }
  .rtps-no-thanks-link {
    margin-top: 10px;
  }
  @media ${(props) => props.theme.mediaQuery.mediumMax} {
    width: 200px;
    padding: 24px 10px 17px;
    height: auto;
    min-height: 440px;
    top: 15vh;

    .rtps-apply-now-button,
    .rtps-no-thanks {
      font-size: 11px;
    }
    .rtps-save-today {
      line-height: 1;
    }
  }
`;

const StyledImage = styled(Image)`
  width: 80%;
`;

const StyledImageWrapper = styled.div`
  margin-right: -10px;
  margin-top: 20px;
  margin-bottom: 10px;
  display: flex;
  justify-content: center;
`;

const SaveTodayWrapper = styled.div`
  padding-bottom: 10px;
`;

export { StyledModal, StyledImage, StyledImageWrapper, SaveTodayWrapper };
